import { useLocation, useNavigate } from "react-router-dom";
import { useUserInfo } from "@/model";
import classNames from "classnames";
import "./index.less";
// import { list } from "../../mock";
import { useMemo } from "react";

const SubMenu = () => {
  const userInfo = useUserInfo();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // const serviceList = list.children;
  const serviceList = useMemo(
    () => userInfo.serviceMenuItems?.children || [],
    [userInfo.serviceMenuItems]
  );

  const goPage: (path: string | undefined) => void = (path = "") => {
    if (!path) return;
    navigate(path);
  };

  return (
    (serviceList && serviceList.length > 0 && (
      <ul className="submenu-wrapper">
        {serviceList.map((item, i) => (
          <li
            key={item.id}
            className={classNames("submenu-box", {
              first: i === 0,
            })}
          >
            <div
              className={classNames("submenu-title", {
                active: pathname === item.resources,
              })}
              onClick={() => {
                goPage(i === 0 ? item.resources : "");
              }}
            >
              <span>{item.comment}</span>
            </div>
            <ul>
              {item.children &&
                item.children.length > 0 &&
                item.children.map((items) => (
                  <li
                    key={items.id}
                    className={classNames("submenu-item", {
                      active: pathname === items.resources,
                    })}
                    onClick={() => {
                      goPage(items.resources);
                    }}
                  >
                    <span>{items.comment}</span>
                  </li>
                ))}
            </ul>
          </li>
        ))}
      </ul>
    )) || <></>
  );
};

export default SubMenu;
